import * as React from "react";
import classNames from "classnames";
import { revoSizeToPadding, flexDirectionMapping, flexAlignMapping, } from "../components/util/layoutconstants";
import { getThemeColorVar } from "../helper/color";
import { css, cx } from "emotion";
import { revoSpecToCss } from "../helper/responsive";
const Alignments = [
    "xs-align",
    "sm-align",
    "md-align",
    "lg-align",
    "xl-align",
];
const Justifies = [
    "xs-justify",
    "sm-justify",
    "md-justify",
    "lg-justify",
    "xl-justify",
];
const isBetterProps = (a) => (a.padding !== undefined || a.gap !== undefined) &&
    (a.paddingX === undefined ||
        a.paddingY === undefined ||
        a.spaceBetween === undefined);
const oldSizeMapping = {
    sm: 2.5,
    base: 5,
    md: 10,
    lg: 15,
    xl: 20,
    xxl: 25,
};
export const FlexContainer = (props) => {
    const { backgroundColor } = props;
    const classes = [
        css({
            display: "flex",
            height: props.height,
        }),
    ];
    backgroundColor &&
        classes.push(css({
            backgroundColor: getThemeColorVar(backgroundColor.color, backgroundColor.colorType),
        }));
    if (props.borderWidth) {
        classes.push(css({
            borderWidth: props.borderWidth.map((e) => `${e}px`).join(" "),
        }));
    }
    if (props.borderStyle) {
        classes.push(css({
            borderStyle: props.borderStyle,
        }));
    }
    if (props.borderColor) {
        classes.push(css({
            borderColor: props.borderColor,
        }));
    }
    if (isBetterProps(props)) {
        props.padding &&
            classes.push(css(revoSpecToCss(props.padding, revoSizeToPadding)));
        props.gap &&
            classes.push(css(revoSpecToCss(props.gap, (i) => {
                if (props.direction === "row-reverse")
                    return {
                        "> :not(:first-child)": {
                            marginRight: i,
                        },
                    };
                else if (props.direction === "col-reverse")
                    return {
                        "> :not(:first-child)": {
                            marginBottom: i,
                        },
                    };
                else if (props.direction === "col")
                    return {
                        "> :not(:last-child)": {
                            marginBottom: i,
                        },
                    };
                else
                    return {
                        "> :not(:last-child)": {
                            marginRight: i,
                        },
                    };
            })));
    }
    else {
        if (props.paddingX) {
            classes.push(css({
                paddingLeft: oldSizeMapping[props.paddingX],
                paddingRight: oldSizeMapping[props.paddingX],
            }));
        }
        if (props.paddingY) {
            classes.push(css({
                paddingTop: oldSizeMapping[props.paddingY],
                paddingBottom: oldSizeMapping[props.paddingY],
            }));
        }
        if (props.spaceBetween) {
            if (props.direction === "col" || props.direction == "col-reverse") {
                classes.push(css({
                    "> :not(:last-child)": {
                        marginBottom: oldSizeMapping[props.spaceBetween],
                    },
                    "> .re-flex__col:not(:last-child)": {
                        marginBottom: 0,
                        paddingBottom: oldSizeMapping[props.spaceBetween],
                    },
                }));
            }
            else if (props.direction === "row" ||
                props.direction === "row-reverse") {
                classes.push(css({
                    "> :not(:last-child)": {
                        marginRight: oldSizeMapping[props.spaceBetween],
                    },
                    "> .re-flex__col:not(:last-child)": {
                        marginRight: 0,
                        paddingRight: oldSizeMapping[props.spaceBetween],
                    },
                }));
            }
        }
    }
    let flexStyle = {
        flexGrow: props.canGrow ? 1 : 0,
        flexShrink: props.canShrink ? 1 : 0,
    };
    if (props.overflow) {
        flexStyle.overflow = props.overflow;
    }
    if (props.flexWrap)
        flexStyle.flexWrap = props.flexWrap;
    else
        flexStyle.flexWrap = "nowrap";
    if (props.basis)
        flexStyle.flexBasis = props.basis;
    Alignments.forEach((alignment) => {
        const val = props[alignment];
        if (val) {
            classes.push(css({
                alignItems: flexAlignMapping[val],
            }));
        }
    });
    Justifies.forEach((alignment) => {
        const val = props[alignment];
        if (val) {
            classes.push(css({
                justifyContent: flexAlignMapping[val],
            }));
        }
    });
    if (props.direction)
        classes.push(css({
            flexDirection: flexDirectionMapping[props.direction],
        }));
    if ((props.direction === "col" || props.direction === "col-reverse") &&
        props.height === undefined) {
        classes.push(css({
            height: "100%",
        }));
    }
    classes.push(css(flexStyle));
    return (React.createElement("div", { className: classNames("revo-flex", cx(classes)) }, props.children));
};
FlexContainer.defaultProps = {
    basis: "auto",
    canGrow: true,
    canShrink: true,
    direction: "row",
};
export default FlexContainer;
//# sourceMappingURL=flexcontainer.js.map